import { create } from 'zustand'
import type { EmbedTheme } from '@/lib/embed'

// Embed handshake state. Only meaningful when the portal runs inside a partner iframe.
//   connecting — waiting for the parent's first qtz:auth
//   ready      — session received from the parent
//   failed     — parent not allowlisted, no reply in time, or signed out
export type EmbedStatus = 'connecting' | 'ready' | 'failed'

interface EmbedState {
  status: EmbedStatus
  routes: string[] | null
  theme: EmbedTheme | null
  setStatus: (status: EmbedStatus) => void
  setRoutes: (routes: string[] | null) => void
  setTheme: (theme: EmbedTheme) => void
}

export const useEmbedStore = create<EmbedState>()((set) => ({
  status: 'connecting',
  routes: null,
  theme: null,
  setStatus: (status) => set({ status }),
  setRoutes: (routes) => set({ routes }),
  setTheme: (theme) => set({ theme }),
}))
